import { render } from "./GeneradorQR.vue?vue&type=template&id=23e96524&scoped=true"
import script from "./GeneradorQR.vue?vue&type=script&lang=js"
export * from "./GeneradorQR.vue?vue&type=script&lang=js"

import "./GeneradorQR.vue?vue&type=style&index=0&id=23e96524&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e96524"]])

export default __exports__